/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagedModelRequest } from './pagedModelRequest';
import { RuleCardSubtypeDetailsViewModel } from './ruleCardSubtypeDetailsViewModel';
import { PagedListMetaData } from './pagedListMetaData';

export interface RuleCardSubtypeDetailsViewModelPagedModelResponse {
  pagedRequest?: PagedModelRequest;
  data?: Array<RuleCardSubtypeDetailsViewModel> | null;
  metaData?: PagedListMetaData;
}
